import TagRegisterContainer from './TagRegisterContainer';
export default TagRegisterContainer;
